import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { pricingApi, type PricingDashboard } from '../../api/pricing';

const NAV = [
  { to: '/pricing/price-books', label: 'Price books' },
  { to: '/pricing/marketplace', label: 'Marketplace pricing' },
  { to: '/pricing/promotions', label: 'Promotions' },
  { to: '/pricing/discounts', label: 'Discounts' },
  { to: '/pricing/coupons', label: 'Coupons' },
  { to: '/pricing/bulk-update', label: 'Bulk price update' },
  { to: '/pricing/analytics', label: 'Pricing analytics' },
  { to: '/pricing/margin', label: 'Margin dashboard' },
  { to: '/pricing/recommendations', label: 'AI recommendations' },
  { to: '/pricing/competitors', label: 'Competitor pricing' },
];

export function PricingHubPage() {
  const [dashboard, setDashboard] = useState<PricingDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void pricingApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Pricing Engine</h1>
      <p className="mt-1 text-sm text-slate-600">Price books, promotions, marketplace pricing, and AI recommendations.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Object.entries(dashboard?.stats ?? {}).map(([k, v]) => (
          <div key={k} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{k.replace(/_/g, ' ')}</p>
            <p className="mt-1 text-2xl font-semibold">{String(v)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
